
import { useEffect, useRef, useState } from 'react';

export default function Problem() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative py-32 px-8 bg-white"
    >
      <div className="max-w-[1200px] mx-auto">
        <div
          className={`text-center space-y-8 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          <h2 className="text-[#09090b] text-[28px] sm:text-[40px] lg:text-[56px] font-bold leading-tight px-2">
            You Shouldn't Have to Choose<br className="hidden sm:block" />
            <span className="sm:hidden"> </span>Between Speed and Safety
          </h2>

          <div className="max-w-[800px] mx-auto space-y-6 text-[#52525b] text-[15px] sm:text-[18px] leading-relaxed px-2">
            <p>
              Every legal AI on the market asks you to upload privileged documents to their servers. Your client names. Your case strategy. Your work product. Sitting on infrastructure you don't control.
            </p>

            <p>
              You know the risk. You've hesitated before hitting upload. You've rewritten prompts to strip out identifying details. You've wondered what happens to that data after you close the tab.
            </p>

            <p className="text-[#09090b] font-medium text-[16px] sm:text-[20px]">
              Meanwhile you're still typing every motion by hand. Still formatting at 11pm. Still billing for work a machine could do in seconds.
            </p>

            <p className="text-[#8B4513] font-semibold text-[18px] sm:text-[22px]">
              There has to be a better way
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
